import { useCallback } from 'react';
import { ActionOutboxEntityType, Tag } from 'src/WebApiController';

import { TagsListItem } from './TagListItem';

export const TagsPanel = ({
  tagMetadatas,
  tagsWithValue,
  onTagsUpdate,
  disabled,
  entityType,
}: {
  tagMetadatas: Tag[];
  tagsWithValue: Tag[];
  disabled?: boolean;
  onTagsUpdate: (tagsCurrentEntity: Tag[]) => void;
  entityType:
    | ActionOutboxEntityType.Listing
    | ActionOutboxEntityType.Purchase
    | ActionOutboxEntityType.Sale
    | ActionOutboxEntityType.SellerEvent;
}) => {
  const onTagChange = useCallback(
    (tag: Tag, newValues: Tag[]) => {
      const newTags = [
        ...tagsWithValue.filter(
          (t) => t.key !== tag.key || t.sourceEntityId !== tag.sourceEntityId
        ),
        ...newValues,
      ]
        .toSorted((t1, t2) => {
          const keyComparison = t1.key.localeCompare(t2.key);
          if (keyComparison !== 0) return keyComparison;
          return (t1.ordinal ?? 0) - (t2.ordinal ?? 0);
        })
        .map((t, i) => ({ ...t, ordinal: i }));
      onTagsUpdate(newTags);
    },
    [onTagsUpdate, tagsWithValue]
  );

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {tagMetadatas.map((tag) => {
        return (
          <TagsListItem
            key={`${tag.key}-${tag.value}-${tag.sourceEntityId}`}
            tagMetadata={tag}
            tagsWithValue={tagsWithValue}
            disabled={disabled}
            onTagChange={onTagChange}
            entityType={entityType}
          />
        );
      })}
    </div>
  );
};
